export default {
  pageNotFound: {
    title: "Page Not Found",
    heading: "Oops! You've Gone Off the Grid (404)",
  },
};
